// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { ServiceFundingOperationsService } from '../generated/api/serviceFundingOperations.service';

@Injectable({ providedIn: 'root' })
export class ServiceFundingOperationsClientService {
  constructor(private readonly client: ServiceFundingOperationsService) {}
  // <generated-client-wrappers:methods>
  account(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FundingBackingResponse> {
    if (!this.client)
      throw new Error('ServiceFundingOperationsService is not available');
    return this.client.serviceFundingOperationsAccount(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  accounts(
    page?: number,
    pageSize?: number,
    merchantId?: string,
    consumerAppId?: string,
    responsibleGlobalUserId?: string,
    audience?: string,
    segmentId?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FundingAccountPage> {
    if (!this.client)
      throw new Error('ServiceFundingOperationsService is not available');
    return this.client.serviceFundingOperationsAccounts(
      page,
      pageSize,
      merchantId,
      consumerAppId,
      responsibleGlobalUserId,
      audience,
      segmentId,
      'body',
      reportProgress,
      options,
    );
  }

  postpaid(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PostpaidAuthorizationResponse> {
    if (!this.client)
      throw new Error('ServiceFundingOperationsService is not available');
    return this.client.serviceFundingOperationsPostpaid(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  prepayment(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ServicePrepaymentResponse> {
    if (!this.client)
      throw new Error('ServiceFundingOperationsService is not available');
    return this.client.serviceFundingOperationsPrepayment(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  propose(
    request: WrapperApi.PostpaidAuthorizationRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PostpaidAuthorizationResponse> {
    if (!this.client)
      throw new Error('ServiceFundingOperationsService is not available');
    return this.client.serviceFundingOperationsPropose(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  retryPublication(
    id: string,
    request: WrapperApi.FundingPublicationRetryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FundingPublicationRetryReceipt> {
    if (!this.client)
      throw new Error('ServiceFundingOperationsService is not available');
    return this.client.serviceFundingOperationsRetryPublication(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  revoke(
    id: string,
    request: WrapperApi.PostpaidRevocationRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.PostpaidAuthorizationResponse> {
    if (!this.client)
      throw new Error('ServiceFundingOperationsService is not available');
    return this.client.serviceFundingOperationsRevoke(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
